import { render, staticRenderFns } from "./waschepacket.vue?vue&type=template&id=11c2523e&"
import script from "./waschepacket.vue?vue&type=script&lang=js&"
export * from "./waschepacket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11c2523e')) {
      api.createRecord('11c2523e', component.options)
    } else {
      api.reload('11c2523e', component.options)
    }
    module.hot.accept("./waschepacket.vue?vue&type=template&id=11c2523e&", function () {
      api.rerender('11c2523e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gFGWRpmJbebf/JS/comp/waschepacket.vue"
export default component.exports